module.exports = __webpack_public_path__ + "static/media/icon-envelope.6dca69fe.svg";